import React from "react";
import { Result } from "antd";
import { Link } from "react-router-dom";

export default function _404() {
  return (
    <div className="h-screen">
      <section>
        <div className="container">
          <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
            extra={<Link to="/">Back to home</Link>}
          />
        </div>
      </section>
    </div>
  );
}
